import React from 'react';
import FeedbackSection from './FeedbackSection';
import { useNavigate } from 'react-router-dom';

const AskQuestion = () => {
  const navigate = useNavigate();

  return (
    <div style={{ 
      maxWidth: '800px', 
      margin: '0 auto', 
      padding: '20px',
      color: 'white'
    }}>
      <div style={{
        marginBottom: '20px',
        marginLeft: '-20px'  // To align with the left edge like in screen selection
      }}>
        <button
          onClick={() => navigate('/custom-builder')}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            background: 'rgba(0, 0, 0, 0.4)',
            border: 'none',
            color: '#fff',
            fontSize: '14px',
            cursor: 'pointer',
            padding: '8px 16px',
            borderRadius: '4px',
            width: 'fit-content'
          }}
        >
          ← Back to Builder
        </button>
      </div>

      <h1 style={{ marginBottom: '20px' }}>Ask a Question or Share Feedback</h1>
      <FeedbackSection showHeader={false} />
    </div>
  );
};

export default AskQuestion; 